import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export const defaults = Object.freeze({
  primary: '#6ED2EE',
  primary_inverse: '#FFFFFF',
  secondary: '#00538A',
  success: '#6ED2EE',
  info: '#71BAFF',
  danger: '#F8706D',
  warning: '#FB8C00',
  accent: '#82B1FF',
  error: '#FF5252',
  itemLabel: '#5C5C5C',
  mainTitleLabel: '#00538A',
  disabled: '#bfbdbd',
  green: '#619437',
  muted: '#cccccc',
  lightGreen: '#9CD291',
  greenTextColor: '#4E8939',
  customNotificationColor: '#FFB300',
  customNotificationColor_inverse: '#FFFFFF',
  listHover: '#eeeeee',
  genderMale: '#E1F5FE',
  genderFemale: '#FCE4EC',
  genderUnknown: '#F1F8E9',
  genderMale_dark: '#03A9F4',
  genderFemale_dark: '#E91E63',
  genderUnknown_dark: '#8BC34A',
  status_active: '#E8F5E9',
  billing_paid: '#8BC34A',
  billing_pending: '#C7A0CB',
  billing_voided: '#98272B',
  alert: '#98272B',
  btnTextColor: '#616161',
  inputBackgroundColor: '#F5F5F5',
  menuSelected: '#FFFFFF',
});

export default new Vuetify({
  theme: {
    options: { customProperties: true },
    themes: {
      light: { ...defaults },
    },
  },
});
